import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const MenuIcon = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M3 12H21M3 7H21M3 17H21",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
